module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', [_c('div', {
    staticClass: "blank"
  }), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.headimgurl
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.user.nickname))])]), _vm._v(" "), _c('div', {
    staticClass: "blank"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'news'
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-oNews"
  }), _vm._v(" "), _c('span', [_vm._v("站内公告")]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-right"
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'suggest'
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-oMail"
  }), _vm._v(" "), _c('span', [_vm._v("留言反馈")]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "blank"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.onRoute('playback')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-oPlay"
  }), _vm._v(" "), _c('span', [_vm._v("播放记录")]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-right"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.onRoute('favourite')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-oStar"
  }), _vm._v(" "), _c('span', [_vm._v("我的收藏")]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-right"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.onRoute('note')
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-oNote"
  }), _vm._v(" "), _c('span', [_vm._v("我的笔记")]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "blank"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onShare
    }
  }, [_c('i', {
    staticClass: "icon icon-oShare"
  }), _vm._v(" "), _c('span', [_vm._v("邀请好友")]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "blank"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-oAbout"
  }), _vm._v(" "), _c('span', [_vm._v("关于我们")]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-right"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53a424dd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/more/index.vue
// module id = 324
// module chunks = 0